import { fontFamily } from "@/styles/font";
import React from "react";
import styled from "styled-components";

const ContentSection = () => {
    return (
        <ContentWrapper>
            <ContentText>콘텐츠를 준비하고 있어요! ✨</ContentText>
            <ContentSubText>그동안 우리술을 즐길 수 있는 공간을 소개할게요.</ContentSubText>
            <ClickText as="a" href="https://maily.so/soolhorang" target="_blank" rel="noopener noreferrer">
                눌러서 확인해보세요!
            </ClickText>
        </ContentWrapper>
    );
};

export default ContentSection;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    text-align: center;
`;

const ContentImage = styled.div`
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
    background: url("/images/tools-icon.png") no-repeat center;
    background-size: contain;
    &:before {
        content: "🛠️";
        font-size: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
`;

const ContentText = styled.p`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #767676;
    margin: 0;
`;

const ContentSubText = styled.p`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 350;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #767676;
    margin: 8px 0 0 0;
`;

const ClickText = styled.p`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #1f1f1f;
    margin: 24px 0 0 0;
    text-decoration: underline;
    cursor: pointer;
`;
